import { AgGridReact } from 'ag-grid-react';

import { WithLocalStorage } from '@/components';
import { useDefaultGridOptions } from '@/grid';
import { defaultColDef } from '@/grid/defaults';
import { GET_EMB_FERT_DATA_BY_DONOR_IDQuery } from '@/rtk-query.gql';
import type { DonorScheduleResponse } from '@/services/aspiration';

import {
  donorCommentsColDefs,
  embGridColumnDefs,
} from '../../utils/columnDefs';

interface Props {
  themeMode: string;
  donorScheduleData: DonorScheduleResponse[];
  embFertDataByDonorId: GET_EMB_FERT_DATA_BY_DONOR_IDQuery;
}

export const OpuSearchFormGrids = ({
  themeMode,
  donorScheduleData,
  embFertDataByDonorId,
}: Props) => {
  const defaultGridOptions = useDefaultGridOptions();
  const theme = `ag-theme-transova${themeMode === 'dark' ? '-dark' : ''}`;

  return (
    <div className="flex h-full w-full flex-col gap-2 overflow-y-auto text-[11px]">
      {/* embryo/fert grid */}
      <div
        className={`h-[15rem] w-full flex-none rounded bg-transparent ${theme}`}
      >
        <WithLocalStorage storageKey="opu-search__emb-grid">
          <AgGridReact
            gridOptions={defaultGridOptions}
            rowData={embFertDataByDonorId?.embFertDataByDonorId}
            defaultColDef={defaultColDef}
            columnDefs={embGridColumnDefs}
            overlayLoadingTemplate="Please Select a Site and a Technician"
            rowSelection="single"
            getRowId={(p) => p.data.id}
          />
        </WithLocalStorage>
      </div>

      {/* donor‑schedule grid */}
      <div
        className={`h-[15rem] w-full flex-none rounded bg-transparent ${theme}`}
      >
        <WithLocalStorage storageKey="opu-search__donor-schedule-grid">
          <AgGridReact
            gridOptions={defaultGridOptions}
            rowData={donorScheduleData}
            defaultColDef={defaultColDef}
            columnDefs={donorCommentsColDefs}
            rowSelection="single"
            getRowId={(p) => p.data.donorCondition}
          />
        </WithLocalStorage>
      </div>
    </div>
  );
};
